import React from 'react';
import { connect } from 'react-redux';
import { UserInfo } from '@amzn/aac-chrome-internal-api';
import { PopoverAction } from '@amzn/storm-ui-page-header';
import { Text } from '@amzn/storm-ui';
import { ACTION_STATE, BUTTON_TYPE, PopoverType } from '../types';
import { RootState } from 'src/app/store';
import { selectUserInfoFromHeader } from 'src/features/header/store/slice';
import {
  mapActionStateToPopoverActionState,
  mapButtonTypeToStormButtonVariant,
} from 'src/features/header/components/PageHeader/utils';

interface ActionsPopoverType extends PopoverType {
  userInfo: UserInfo;
}

const popoverContent = (content, contentType) =>
  content &&
  (contentType === 'HTML' ? (
    <Text dangerouslySetInnerHTML={{ __html: content }} renderAs="span" />
  ) : (
    <Text>{content}</Text>
  ));

export const ActionsPopover: React.VFC<ActionsPopoverType> = ({
  id,
  label,
  state,
  content,
  contentType,
  buttonType,
  tooltipPosition,
  ariaLabel,
  userInfo,
}) => (
  <PopoverAction
    id={id}
    label={label}
    state={mapActionStateToPopoverActionState(state ?? ACTION_STATE.ENABLED)}
    buttonVariant={mapButtonTypeToStormButtonVariant(
      buttonType ?? BUTTON_TYPE.NORMAL,
    )}
    popoverPosition={tooltipPosition}
    locale={userInfo.languageInfo.currentLocale}
    aria-label={ariaLabel}
    data-ccx-e2e-id={`aac-action-${id}`}
  >
    {popoverContent(content, contentType)}
  </PopoverAction>
);

const mapStateToProps = (state: RootState) => {
  return {
    userInfo: selectUserInfoFromHeader(state),
  };
};

export const ConnectedActionsPopover = connect(mapStateToProps)(ActionsPopover);
